import { CommentAuthor } from './CommentAuthor';
import { Comment as CommentBase } from '@ant-design/compatible';
import { coreActions } from '@sonar-software/sonar-core';
import { CurrentUserAvatar } from '@ui/header';
import { Editor } from '@ui/Editor';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';
export const NewComment = ({ initiativeId }) => {
    const save = useAction(coreActions.requestPostCoreInitiativesComments);
    const handleSave = useCallback((body, bodyHtml, taggedUsers) => save({
        body,
        bodyHtml,
        initiativeId,
        taggedUsers
    }), [initiativeId, save]);
    return (React.createElement(CommentBase, { author: React.createElement(CommentAuthor, { isCurrentUser: true }), avatar: React.createElement(CurrentUserAvatar, null), className: 'initiative-comment', content: React.createElement(Editor, { bordered: true, content: '', editOnClick: true, enableMentions: true, isForm: true, onSave: handleSave, placeholder: PLACEHOLDERS_COPY.ADD_A_COMMENT }) }));
};
